import QuinielaGroupsLobby from './QuinielaGroupsLobby';
export default QuinielaGroupsLobby;